import { render } from "./SupportCategory.vue?vue&type=template&id=5cd941be"
import script from "./SupportCategory.vue?vue&type=script&lang=js"
export * from "./SupportCategory.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2456369213/src/mpz-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__